"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleResultCardCallout = void 0;
const react_1 = __importDefault(require("react"));
const ExampleResultCardCallout = (props) => {
    const styleProp = react_1.default.useMemo(() => {
        var _a, _b;
        return ({
            gridRow: `span ${(_a = props.callout.displayRows) !== null && _a !== void 0 ? _a : 1}`,
            gridColumn: `span ${(_b = props.callout.displayColumns) !== null && _b !== void 0 ? _b : 1}`,
        });
    }, [props.callout]);
    return (react_1.default.createElement("div", { className: "rs__result-card-callout", ref: props.itemRef, style: styleProp },
        react_1.default.createElement("a", Object.assign({ className: "rs__result-card-callout__link", onClick: props.handleClick }, (!!props.callout.link && { href: props.callout.link })),
            props.callout.desktopImage && (react_1.default.createElement("img", { className: "rs__result-card-callout__image", src: props.callout.desktopImage, width: "100%", height: "190px" })),
            react_1.default.createElement("span", { className: "rs__result-card-callout__title" }, props.callout.title))));
};
exports.ExampleResultCardCallout = ExampleResultCardCallout;
//# sourceMappingURL=ExampleResultCardCallout.js.map